var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageAdd = function SvgImageAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5h13v7h2V5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h8v-2H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 11-3 4h11l-4-6-3 4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
  })));
};
export default SvgImageAdd;